module.exports = __webpack_public_path__ + "img/nettanlegg.63dbd902.jpg";